/**
 * Why the Dashboard sent someone to High Guide, passed as the `redirectReason` query param on the High Guide sign-in
 * URL so it can explain the jump. High Guide keeps a matching copy of this contract.
 */
export enum HighGuideRedirectReason {
  DashboardAccessDenied = 'DashboardAccessDenied'
}
